import { Image, ImageFit, Stack, useTheme } from "@fluentui/react";
import React, { useEffect } from "react";
import { getAepPayloadContentType } from "../../../externalApi/AepApi";
import { addVisibilityEventListeners, getIsWindowVisible, getLastShowReason, removeVisibilityEventListeners } from "../../../externalApi/WindowApi";
import { getResources } from "../../../getResources";
import { Button } from "../../generic/Button/Button";
import { getWideDefaultButtonStyle } from "../../generic/Button/Button.styles";
import { Grid } from "../../generic/Grid/Grid";
import { Text } from "../../generic/Text/Text";
import { getContainerStyle, getCTAOfflineImageStyle } from "./CTAOfflinePage.styles";
import { logPageEvent, logPageHidden, logPageShown } from "../Telemetry/PageTelemetry";
import { useCtaSettingContext } from "../../../contexts/CtaSettingContext";
const CTAOfflinePage = (props) => {
    const ctaSettingContext = useCtaSettingContext();
    const handleWindowShown = async () => {
        try {
            const [aepPayloadContentType, lastShowReason] = await Promise.all([
                getAepPayloadContentType(),
                getLastShowReason(),
            ]);
            logPageShown("cta-offline", aepPayloadContentType, lastShowReason);
        }
        catch (error) {
            console.error("An error occurred while handling the window shown:", error);
        }
    };
    const handleWindowHidden = () => {
        logPageHidden("cta-offline");
    };
    useEffect(() => {
        logPageEvent("cta-offline");
        addVisibilityEventListeners(handleWindowShown, handleWindowHidden);
        // If the Window is visible, fire the visibility event since we will have missed the first one on cold launch.
        getIsWindowVisible().then((visible) => {
            if (visible) {
                handleWindowShown();
            }
        }, (reason) => {
            // If windowAPI is unavailable, do nothing
        });
        return () => {
            removeVisibilityEventListeners(handleWindowShown, handleWindowHidden);
        };
    }, []);
    const theme = useTheme();
    const offlineImageProps = {
        imageFit: ImageFit.contain,
        src: theme.customImages.globalOfflineImage,
    };
    const ariaLabel = getResources().CTAOfflinePage_OfflineErrorMessage + " " + getResources().CTAOfflinePage_OfflineErrorSubtext;
    return (React.createElement("div", { onClick: (e) => { var _a; return (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, e); }, style: { height: "100%" } },
        React.createElement(Stack, { id: "cta-offline-page", "aria-label": ariaLabel, horizontalAlign: "center", verticalAlign: "center", styles: getContainerStyle() },
            React.createElement(Image, Object.assign({}, offlineImageProps, { id: "offline-logo", alt: "", styles: getCTAOfflineImageStyle() })),
            React.createElement(Text, { variant: "xxLarge", marginBottom: "12px", role: "heading", "aria-level": "1" }, getResources().CTAOfflinePage_OfflineErrorMessage),
            React.createElement(Text, { variant: "medium", marginBottom: "28px" }, getResources().CTAOfflinePage_OfflineErrorSubtext),
            React.createElement(Grid, { tokens: { childrenGap: 15, columns: 2 } },
                React.createElement(Button, { id: "cancel-button", onClick: () => ctaSettingContext.setIsMeteredConnectionUsageAllowedSetting(false), styles: getWideDefaultButtonStyle() }, getResources().CTAOfflinePage_CancelButtonText),
                React.createElement(Button, { id: "turnon-button", primary: true, styles: getWideDefaultButtonStyle(), onClick: () => ctaSettingContext.setIsMeteredConnectionUsageAllowedSetting(true) }, getResources().CTAOfflinePage_TurnOnButtonText)))));
};
export default CTAOfflinePage;
